import { render, staticRenderFns } from "./VRLayout.vue?vue&type=template&id=b0cbed6e&"
import script from "./VRLayout.vue?vue&type=script&lang=ts&"
export * from "./VRLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports